import React from 'react'
import styles from './style/custom_products_banner_call_to_action_style.module.scss'
import backgroundImageV2 from '../../../assets/img/cut-to-size/Path-v2.png'
import LocalizedLink from '../../global/LocalizedLink'
import Translation from '../../global/Translation'

const CustomProductsBannerCallToAction = (props) => {
    const { hasPreOrder } = props

    return (
        <div className={styles['custom-products-banner-cta']}>
            <div className={styles['custom-products-banner-cta__card']}>

                <div className={styles['custom-products-banner-cta__image-wrapper']}>
                    <img
                        src={backgroundImageV2}
                        alt="Request an order"
                        className={styles['custom-products-banner-cta__image']}
                    />
                </div>

                <div className={styles['custom-products-banner-cta__content']}>
                    <h3 className={styles['custom-products-banner-cta__title']}>
                        <Translation
                            id="dont_find_your_cut"
                            defaultMessage="Don't find the cut to size you need?"
                        />
                    </h3>

                    <p className={styles['custom-products-banner-cta__description']}>
                        <Translation id={"access_the_form_and_attach_your_floor_plan_our_technical_team_review"} defaultMessage={"Access the form and attach your floor plan. Our technical team will review it and send you a quote."} />
                    </p>

                    <LocalizedLink
                        routeId={'ROUTE_CUT_TO_SIZE'}
                        header={true}
                        queryString={`?type=${hasPreOrder ? 'preorder' : 'budget'}`}
                        params={{ outlet: '' }}
                        className={styles['custom-products-banner-cta__link']}
                        dataQas="cts_main_request-quotation-button"
                        gtmLabel="custom-products_link_go-to--quote-form"
                    >
                        <Translation
                            id="request_for_quote"
                            defaultMessage="Request for quote"
                        />
                        <i className="fas fa-chevron-right"></i>
                    </LocalizedLink>
                </div>

            </div>
        </div>
    )
}

export default CustomProductsBannerCallToAction
 